import { ProductOrBrand } from "./alternativeTypes";

export const personalCareProducts: ProductOrBrand[] = [
  // Personal Care
  {
    name: "Gillette",
    ownerCountry: "US", // Procter & Gamble
    categories: ["personal-care", "shaving"],    
  },
  {
    name: "Always",
    ownerCountry: "US", // Procter & Gamble
    categories: ["personal-care", "menstruation"],    
  },
  {
    name: "Pampers",
    ownerCountry: "US", // Procter & Gamble
    categories: ["personal-care", "baby"],    
  },
  {
    name: "Huggies",
    ownerCountry: "US",
    comments: "Kimberly-Clark",
    availableIn: ["FR", "BE", "UK", "NL"],
    categories: ["personal-care", "baby"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Kimberly-Clark"]
  },
  {
    name: "Oral‑B",
    ownerCountry: "US", // Procter & Gamble
    categories: ["personal-care", "tooth"],    
  },
  {
    name: "Colgate",
    ownerCountry: "US",
    categories: ["personal-care", "tooth"],    
  },
  {
    name: "Crest",
    ownerCountry: "US",
    availableIn: ["CA"],
    categories: ["personal-care", "tooth"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Crest_(toothpaste)"]
  },
  {
    name: "Elmex",
    ownerCountry: "US",
    headquarterIn: "CH",
    comments: "Elmex is a brand of toothpaste produced by GABA International AG, a Swiss company purchased by Colgate-Palmolive (US)",
    availableIn: ["FR", "DE", "NL", "BE", "CH", "ES"],
    categories: ["personal-care", "tooth"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Elmex"]    
  },
  {
    name: "Pantene",
    ownerCountry: "US", // Procter & Gamble
    categories: ["personal-care", "hair"],    
  },
  {
    name: "Head & Shoulders",
    ownerCountry: "US", // Procter & Gamble
    categories: ["personal-care", "hair"],    
  },
  {
    name: "Palmolive",
    ownerCountry: "US",
    categories: ["personal-care", "hair", "hygiene"],    
  },
  {
    name: "Olay",
    ownerCountry: "US", // Procter & Gamble
    categories: ["personal-care", "skin"],    
  },
  /* 🇫🇷 BiC, 🇸🇪 Libresse, 🇸🇪 Libero, 🇬🇧 Aquafresh,🇬🇧 Dove, 🇵🇱 Ziaja, 🇫🇷 Garnier, 🇩🇪 Nivea */
  {
    name: "BiC",
    ownerCountry: "FR",
    categories: ["personal-care", "shaving"],    
  },
  {
    name: "joni",
    ownerCountry: "CA",
    availableIn: ["CA"],
    comments: "Plant-based bamboo pads and cotton tampons, organic and biodegradable. Consumer period care products and wholesale dispenser solutions for businesses.",
    categories: ["personal-care", "menstruation"],
    sourceLinks: ["https://getjoni.com"]
  },
  {
    name: "DivaCup",
    ownerCountry: "CA",
    availableIn: ["CA"],
    comments: "The DivaCup (Feminine Hygiene / Menstrual Cup)",
    categories: ["personal-care", "menstruation"],
    sourceLinks: ["https://shopdiva.ca/"]
  },
  {
    name: "Libresse",
    ownerCountry: "SE",
    availableIn: [
      "NO", "SE", "FI", "DK", "BG", "HR", "GR", "NL",
      "RO", "UA"
    ],
    comments: "Libresse is a global brand, operating under a number of different names in local markets – Bodyform, Nana, Nuvenia, Saba, Nosotras, Libresse, and Libra.",
    categories: ["personal-care", "menstruation"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Libresse"]
  },
  {
    name: "Nana",
    ownerCountry: "SE",
    availableIn: ["FR", "BE"],
    comments: "French Libresse",
    categories: ["personal-care", "menstruation"],
    sourceLinks: ["https://shop.nana.fr/", "https://www.nana.be/"]
  },
  {
    name: "Nuvenia",
    ownerCountry: "SE",
    availableIn: ["IT"],
    comments: "Italian Libresse",
    categories: ["personal-care", "menstruation"],
    sourceLinks: ["https://shop.nana.fr/", "https://www.nana.be/"]
  },
  {
    name: "Bodyform",
    ownerCountry: "SE",
    availableIn: ["UK", "IE"],
    comments: "UK and Ireland Libresse",
    categories: ["personal-care", "menstruation"],
    sourceLinks: ["https://shop.nana.fr/", "https://www.nana.be/"]
  },
  {
    name: "Saba",
    ownerCountry: "SE",
    availableIn: ["MX"],
    comments: "Mexican Libresse",
    categories: ["personal-care", "menstruation"],
    sourceLinks: ["https://shop.nana.fr/", "https://www.nana.be/"]
  },
  {
    name: "Libero",
    ownerCountry: "SE",
    availableIn: ["SE", "NO", "DK", "FI"],
    categories: ["personal-care", "baby"],
    sourceLinks: ["https://www.libero.com"]
  },
  {
    name: "Lotus",
    ownerCountry: "SE",
    // TODO available in
    availableIn: ["FR"],
    categories: ["personal-care", "baby"],
    sourceLinks: ["https://www.lotusbaby.fr/nos-produits/"]
  },
  {
    name: "Baby",
    ownerCountry: "FR",
    comments: "Carrefour brand",
    availableIn: ["FR", "BE"],
    // TODO available in
    categories: ["personal-care", "baby"],    
  },
  {
    name: "Biolane",
    ownerCountry: "FR", // TODO hard to look up. Seemingly a brand of Biopha, but can't find anything about Biopha
    availableIn: ["FR"],
    categories: ["personal-care", "baby"],
    sourceLinks: ["https://biolane.fr"]
  },
  {
    name: "elkos", // Baby Glück
    ownerCountry: "DE",
    availableIn: ["DE"],
    categories: ["personal-care", "baby"],
    sourceLinks: ["https://www.edeka.de/ernaehrung/beauty/babyglueck.jsp"]
  },
  {
    name: "Aquafresh",
    ownerCountry: "UK",
    comments: "Owned by Haleon (British multinational company)",
    availableIn: ["FR", "NO", "UK", "PL", "NL", "BE", "SE"],
    categories: ["personal-care", "tooth"],    
  },
  {
    name: "Sensodyne",
    ownerCountry: "UK",
    comments: "Owned by Haleon (British multinational company)",
    availableIn: [
      "FR", "NO", "UK", "ES", "PL", "DE", "NL", "BE",
      "SE", "FI", "DK", "CA"
    ],
    categories: ["personal-care", "tooth"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Sensodyne"]
  },
  {
    name: "Solidox",
    ownerCountry: "NO",
    availableIn: ["NO"],
    // TODO available in
    categories: ["personal-care", "tooth"],    
  },
  {
    name: "Jordan",
    ownerCountry: "NO",
    availableIn: ["NO", "FR", "BE", "SE", "FI", "DK"],
    // TODO available in
    categories: ["personal-care", "tooth"],    
  },
  {
    name: "Zerro",
    ownerCountry: "CA",
    availableIn: ["CA"],
    categories: ["personal-care", "tooth"],    
    sourceLinks: ["https://zerro.ca"],    
  },
  {
    name: "Dove",
    ownerCountry: "UK",
    // TODO available in
    categories: ["personal-care", "hair", "hygiene"],    
  },
  {
    name: "Natural Refresh",
    ownerCountry: "CA",
    availableIn: ["CA"],
    categories: ["personal-care", "hair"],
    sourceLinks: ["https://naturalrefresh.ca"]
  },
  {
    name: "Ziaja",
    ownerCountry: "PL",
    availableIn: ["PL"], // TODO available in
    categories: ["personal-care", "skin", "hygiene", "hair"],    
  },
  {
    name: "Daxxin",
    ownerCountry: "SE",
    availableIn: ["NO", "SE", "DK"],
    categories: ["personal-care", "hair"],
    sourceLinks: ["https://daxxin.com"]
  },
  {
    name: "Garnier",
    ownerCountry: "FR",
    // TODO available in
    categories: ["personal-care", "hair"],    
  },
  {
    name: "L'Oréal",
    ownerCountry: "FR",
    comments: "L'Oréal",
    categories: ["personal-care", "hair"],    
  },
  {
    name: "Nivea",
    ownerCountry: "DE",
    // TODO available in
    categories: ["personal-care", "skin"],    
  },
  {
    name: "Wild Prairie",
    ownerCountry: "CA",
    availableIn: ["CA"],
    categories: ["personal-care", "skin"],
    sourceLinks: ["https://www.wildprairiesoap.ca"]
  },
  {
    name: "Biały Jeleń",
    ownerCountry: "PL",
    headquarterIn: "PL",
    availableIn: ["PL"],
    comments: "Polish brand known for producing hypoallergenic personal care products, including soaps and shampoos, catering to individuals with sensitive skin.",
    categories: ["personal-care", "hair"],
    sourceLinks: []
  },
];